import type { DisciplineState } from '@features/instructors/api/types/instructor.types';

import { CobaltTooltip } from '@cae/cobalt-react/components/tooltip';
import { CobaltIconCheckmarkCircleOutline } from '@cae/cobalt-react/icons/outline/CobaltIconCheckmarkCircleOutline';
import { CobaltIconClockOutline } from '@cae/cobalt-react/icons/outline/CobaltIconClockOutline';
import { CobaltIconRemoveOutline } from '@cae/cobalt-react/icons/outline/CobaltIconRemoveOutline';
import { CobaltIconCheckmarkCircleSolid } from '@cae/cobalt-react/icons/solid/CobaltIconCheckmarkCircleSolid';
import * as React from 'react';

import styles from './InstructorDetailPanel.module.css';

type DisciplineIconConfig = {
  Icon: React.ComponentType<{ className?: string }>;
  className?: string;
  tooltipLabel: string;
};

const DISCIPLINE_ICON_CONFIG: Partial<
  Record<DisciplineState, DisciplineIconConfig>
> = {
  Unauthorized: {
    Icon: CobaltIconRemoveOutline,
    className: styles.disciplineIconSecondary,
    tooltipLabel: 'Unauthorized',
  },
  Approved: {
    Icon: CobaltIconCheckmarkCircleSolid,
    className: styles.disciplineIconApproved,
    tooltipLabel: 'Approved',
  },
  Unapproved: {
    Icon: CobaltIconCheckmarkCircleOutline,
    className: styles.disciplineIconUnapproved,
    tooltipLabel: 'Unapproved',
  },
  Pending: {
    Icon: CobaltIconClockOutline,
    className: styles.disciplineIconSecondary,
    tooltipLabel: 'Pending approval',
  },
  PendingRemoval: {
    Icon: CobaltIconClockOutline,
    className: styles.disciplineIconSecondary,
    tooltipLabel: 'Pending revocation',
  },
  PendingApprovalLetter: {
    Icon: CobaltIconClockOutline,
    className: styles.disciplineIconSecondary,
    tooltipLabel: 'Pending approval letter',
  },
};

export function getIcon(state: DisciplineState): React.ReactElement | null {
  const config = DISCIPLINE_ICON_CONFIG[state];
  if (!config) return null;
  return (
    <CobaltTooltip label={config.tooltipLabel} position="bottom">
      <config.Icon className={config.className} />
    </CobaltTooltip>
  );
}
